import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CallType = /*#__PURE__*/function (CallType) {
  CallType[CallType["CALL_TYPE_INVALID"] = 0] = "CALL_TYPE_INVALID";
  CallType[CallType["CALL_TYPE_INBOUND"] = 1] = "CALL_TYPE_INBOUND";
  CallType[CallType["CALL_TYPE_OUTBOUND"] = 2] = "CALL_TYPE_OUTBOUND";
  return CallType;
}(CallType || {});
var Participant = /*#__PURE__*/function (Participant) {
  Participant[Participant["PARTICIPANT_INVALID"] = 0] = "PARTICIPANT_INVALID";
  Participant[Participant["PARTICIPANT_FROM"] = 1] = "PARTICIPANT_FROM";
  Participant[Participant["PARTICIPANT_TO"] = 2] = "PARTICIPANT_TO";
  return Participant;
}(Participant || {});
var VendorModel = /*#__PURE__*/function (VendorModel) {
  VendorModel[VendorModel["VENDOR_MODEL_UNSPECIFIED"] = 0] = "VENDOR_MODEL_UNSPECIFIED";
  VendorModel[VendorModel["VENDOR_MODEL_OPEN_AI_REALTIME"] = 1] = "VENDOR_MODEL_OPEN_AI_REALTIME";
  return VendorModel;
}(VendorModel || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NamespaceAccountGroupNamespace {
  static fromProto(proto) {
    let m = new NamespaceAccountGroupNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    if (proto.accountGroupNamespace) {
      m.accountGroupNamespace = NamespaceAccountGroupNamespace.fromProto(proto.accountGroupNamespace);
    }
    if (proto.partnerNamespace) {
      m.partnerNamespace = NamespacePartnerNamespace.fromProto(proto.partnerNamespace);
    }
    if (proto.systemNamespace) {
      m.systemNamespace = NamespaceSystemNamespace.fromProto(proto.systemNamespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNamespace !== 'undefined' && this.accountGroupNamespace !== null) {
      toReturn['accountGroupNamespace'] = 'toApiJson' in this.accountGroupNamespace ? this.accountGroupNamespace.toApiJson() : this.accountGroupNamespace;
    }
    if (typeof this.partnerNamespace !== 'undefined' && this.partnerNamespace !== null) {
      toReturn['partnerNamespace'] = 'toApiJson' in this.partnerNamespace ? this.partnerNamespace.toApiJson() : this.partnerNamespace;
    }
    if (typeof this.systemNamespace !== 'undefined' && this.systemNamespace !== null) {
      toReturn['systemNamespace'] = 'toApiJson' in this.systemNamespace ? this.systemNamespace.toApiJson() : this.systemNamespace;
    }
    return toReturn;
  }
}
class NamespacePartnerNamespace {
  static fromProto(proto) {
    let m = new NamespacePartnerNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class NamespaceSystemNamespace {
  static fromProto(proto) {
    let m = new NamespaceSystemNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CallRecord {
  static fromProto(proto) {
    let m = new CallRecord();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.transcript) {
      m.transcript = proto.transcript.map(TranscriptMessage.fromProto);
    }
    if (proto.callType) {
      m.callType = enumStringToValue$1(CallType, proto.callType);
    }
    if (proto.callDuration) {
      m.callDuration = parseInt(proto.callDuration, 10);
    }
    if (proto.metadata) {
      m.metadata = Metadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.transcript !== 'undefined' && this.transcript !== null) {
      toReturn['transcript'] = 'toApiJson' in this.transcript ? this.transcript.toApiJson() : this.transcript;
    }
    if (typeof this.audioRecordingUrl !== 'undefined') {
      toReturn['audioRecordingUrl'] = this.audioRecordingUrl;
    }
    if (typeof this.callType !== 'undefined') {
      toReturn['callType'] = this.callType;
    }
    if (typeof this.fromPhoneNumber !== 'undefined') {
      toReturn['fromPhoneNumber'] = this.fromPhoneNumber;
    }
    if (typeof this.toPhoneNumber !== 'undefined') {
      toReturn['toPhoneNumber'] = this.toPhoneNumber;
    }
    if (typeof this.callDuration !== 'undefined') {
      toReturn['callDuration'] = this.callDuration;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class Metadata {
  static fromProto(proto) {
    let m = new Metadata();
    m = Object.assign(m, proto);
    if (proto.voiceConfig) {
      m.voiceConfig = VoiceConfig.fromProto(proto.voiceConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.voiceConfig !== 'undefined' && this.voiceConfig !== null) {
      toReturn['voiceConfig'] = 'toApiJson' in this.voiceConfig ? this.voiceConfig.toApiJson() : this.voiceConfig;
    }
    if (typeof this.assistantId !== 'undefined') {
      toReturn['assistantId'] = this.assistantId;
    }
    return toReturn;
  }
}
class OpenAIRealtimeConfig {
  static fromProto(proto) {
    let m = new OpenAIRealtimeConfig();
    m = Object.assign(m, proto);
    if (proto.turnDetection) {
      m.turnDetection = OpenAIRealtimeConfigTurnDetection.fromProto(proto.turnDetection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.voice !== 'undefined') {
      toReturn['voice'] = this.voice;
    }
    if (typeof this.turnDetection !== 'undefined' && this.turnDetection !== null) {
      toReturn['turnDetection'] = 'toApiJson' in this.turnDetection ? this.turnDetection.toApiJson() : this.turnDetection;
    }
    return toReturn;
  }
}
class TranscriptMessage {
  static fromProto(proto) {
    let m = new TranscriptMessage();
    m = Object.assign(m, proto);
    if (proto.participant) {
      m.participant = enumStringToValue$1(Participant, proto.participant);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.itemId !== 'undefined') {
      toReturn['itemId'] = this.itemId;
    }
    if (typeof this.participant !== 'undefined') {
      toReturn['participant'] = this.participant;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    return toReturn;
  }
}
class OpenAIRealtimeConfigTurnDetection {
  static fromProto(proto) {
    let m = new OpenAIRealtimeConfigTurnDetection();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.threshold !== 'undefined') {
      toReturn['threshold'] = this.threshold;
    }
    if (typeof this.prefixPadding !== 'undefined') {
      toReturn['prefixPadding'] = this.prefixPadding;
    }
    if (typeof this.silenceDuration !== 'undefined') {
      toReturn['silenceDuration'] = this.silenceDuration;
    }
    return toReturn;
  }
}
class VoiceConfig {
  static fromProto(proto) {
    let m = new VoiceConfig();
    m = Object.assign(m, proto);
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue$1(VendorModel, proto.vendorModel);
    }
    if (proto.openaiRealtimeConfig) {
      m.openaiRealtimeConfig = OpenAIRealtimeConfig.fromProto(proto.openaiRealtimeConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.openaiRealtimeConfig !== 'undefined' && this.openaiRealtimeConfig !== null) {
      toReturn['openaiRealtimeConfig'] = 'toApiJson' in this.openaiRealtimeConfig ? this.openaiRealtimeConfig.toApiJson() : this.openaiRealtimeConfig;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetCallRecordRequest {
  static fromProto(proto) {
    let m = new GetCallRecordRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetCallRecordResponse {
  static fromProto(proto) {
    let m = new GetCallRecordResponse();
    m = Object.assign(m, proto);
    if (proto.callRecord) {
      m.callRecord = CallRecord.fromProto(proto.callRecord);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.callRecord !== 'undefined' && this.callRecord !== null) {
      toReturn['callRecord'] = 'toApiJson' in this.callRecord ? this.callRecord.toApiJson() : this.callRecord;
    }
    return toReturn;
  }
}
class GetCallUsageRequest {
  static fromProto(proto) {
    let m = new GetCallUsageRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class GetCallUsageResponse {
  static fromProto(proto) {
    let m = new GetCallUsageResponse();
    m = Object.assign(m, proto);
    if (proto.startTime) {
      m.startTime = new Date(proto.startTime);
    }
    if (proto.endTime) {
      m.endTime = new Date(proto.endTime);
    }
    if (proto.totalDuration) {
      m.totalDuration = parseInt(proto.totalDuration, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.endTime !== 'undefined' && this.endTime !== null) {
      toReturn['endTime'] = 'toApiJson' in this.endTime ? this.endTime.toApiJson() : this.endTime;
    }
    if (typeof this.totalDuration !== 'undefined') {
      toReturn['totalDuration'] = this.totalDuration;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'voice-api.vendasta-local.com',
  'test': '',
  'demo': 'voice-demo.apigateway.co',
  'prod': 'voice-prod.apigateway.co',
  'production': 'voice-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VoiceApiService = /*#__PURE__*/(() => {
  class VoiceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCallRecord(r) {
      const request = r.toApiJson ? r : new GetCallRecordRequest(r);
      return this.http.post(this._host + "/voice.v1alpha1.VoiceService/GetCallRecord", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCallRecordResponse.fromProto(resp)));
    }
    getCallUsage(r) {
      const request = r.toApiJson ? r : new GetCallUsageRequest(r);
      return this.http.post(this._host + "/voice.v1alpha1.VoiceService/GetCallUsage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCallUsageResponse.fromProto(resp)));
    }
  }
  VoiceApiService.ɵfac = function VoiceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || VoiceApiService)();
  };
  VoiceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VoiceApiService,
    factory: VoiceApiService.ɵfac,
    providedIn: 'root'
  });
  return VoiceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, CallRecord, CallType, GetCallRecordRequest, GetCallRecordResponse, GetCallUsageRequest, GetCallUsageResponse, HostService, Metadata, Namespace, NamespaceAccountGroupNamespace, NamespacePartnerNamespace, NamespaceSystemNamespace, OpenAIRealtimeConfig, OpenAIRealtimeConfigTurnDetection, Participant, TranscriptMessage, VendorModel, VoiceApiService, VoiceConfig };
